/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveCabinetIcon32Regular = forwardRef('ArchiveCabinetIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M12 10a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M13 21a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 2A5.5 5.5 0 0 0 5 7.5v17a5.5 5.5 0 0 0 5.5 5.5h11a5.5 5.5 0 0 0 5.5-5.5v-17A5.5 5.5 0 0 0 21.5 2h-11ZM25 15V7.5A3.5 3.5 0 0 0 21.5 4h-11A3.5 3.5 0 0 0 7 7.5V15h18ZM7 17h18v7.5a3.5 3.5 0 0 1-3.5 3.5h-11A3.5 3.5 0 0 1 7 24.5V17Z" })));
});
